import { render, staticRenderFns } from "./WorkflowTaskEditDialog.vue?vue&type=template&id=15d37f1a"
import script from "./WorkflowTaskEditDialog.vue?vue&type=script&lang=js"
export * from "./WorkflowTaskEditDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports